<template>
  <el-dialog
    v-loading="isLoading"
    title="申请退款"
    :visible.sync="dialogFormVisible"
    top="8vh"
    width="600px"
    element-loading-text="加载中"
    @close="close"
  >
    <el-form
      v-if="dialogFormVisible"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item
        label="退款金额"
        prop="price_tui"
        style="margin-bottom: 15px"
      >
        <el-input
          v-model="form.price_tui"
          type="text"
          show-word-limit
          maxlength="10"
          :placeholder="placeholder"
          @input="inputChange"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请原因" prop="dsc">
        <el-input
          v-model="form.dsc"
          show-word-limit
          type="textarea"
          maxlength="50"
          placeholder="请输入申请原因"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { round } from 'lodash'
  import {
    orderRefundRefund,
    GoodsOrder_refund_order_spec,
    orderDetail,
  } from '@/api/xgcApi'
  export default {
    name: 'TuikuanProxyPayment',
    data() {
      return {
        dialogFormVisible: false,
        isLoading: false,
        form: {
          id: '',
          price_tui: null, //退款金额
          dsc: '', //退款原因
        },
        placeholder: '',
        rules: {
          price_tui: [
            {
              required: true,
              message: '请输退款金额',
              trigger: 'change',
            },
          ],
          dsc: [
            {
              required: true,
              message: '请输入申请原因',
              trigger: 'change',
            },
          ],
        },
        type: 1,
      }
    },

    created() {},
    methods: {
      close() {
        this.dialogFormVisible = false
      },
      /**
       * 简化版：只做基础格式化和限制
       */
      inputChange(value) {
        // 1. 只保留数字和小数点
        let cleaned = value.toString().replace(/[^\d.]/g, '')

        // 2. 限制只能有一个小数点
        const parts = cleaned.split('.')
        if (parts.length > 2) {
          cleaned = parts[0] + '.' + parts.slice(1).join('')
        }

        // 3. 限制小数点后两位
        if (parts.length === 2 && parts[1].length > 2) {
          cleaned = parts[0] + '.' + parts[1].substring(0, 2)
        }

        // 4. 限制最大退款金额
        if (this.max && parseFloat(cleaned) > parseFloat(this.max)) {
          cleaned = this.max
          this.$baseMessage(`退款金额不能超过${this.max}元`, 'warning')
        }

        // 5. 更新数据
        this.form.price_tui = cleaned
      },

      open(row, type) {
        this.form.id = row.id
        var data = {
          id: row.id,
        }
        this.type = type
        orderDetail(data).then((res) => {
          // 现金支付/现金积分混合支付
          this.max = Number(row.price) - Number(row.refund_price)
          this.max = this.max.toFixed(2)
          this.placeholder = `退团金额不能超过${this.max}元`
          this.form.price_tui = null
          this.form.dsc = ''
          this.dialogFormVisible = true
        })
      },
      save() {
        var date = {
          id: this.form.id,
          price: this.form.price_tui,
          type: this.type, //1正常包裹 2补拍 3代买 4代发 5代买商品
          refund_remarks: this.form.dsc, //退款理由
        }
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.isLoading = true
            orderRefundRefund(date)
              .then((res) => {
                this.$baseMessage('操作成功', 'success')
                this.$emit('change', true)
                this.dialogFormVisible = false
                this.isLoading = false
              })
              .catch((err) => {
                this.isLoading = false
              })
          } else {
            return false
          }
        })
      },
    },
  }
</script>
<style scoped>
  :deep .el-select > .el-input {
    width: 430px;
  }
  .tui_sku_class {
    border: 1px solid #ccc;
    border-radius: 10px;
    margin-bottom: 8px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tui_sku_class_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
